"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHelmet = require("react-helmet");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const jsonLinkedDataOnly = script => script.type === 'application/ld+json';
function Head({
  head
}) {
  return /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, {
    title: head.title,
    meta: [{
      name: 'description',
      content: head.description
    }, {
      name: 'keywords',
      content: head.keywords
    }].concat(head.meta ? head.meta : []),
    link: [{
      rel: 'canonical',
      href: head.canonical
    }].concat(head.alternate ? head.alternate.map(alternateLink => ({
      rel: 'alternate',
      href: alternateLink.href,
      hrefLang: alternateLink.lang
    })) : []),
    script: head.script ? head.script.filter(jsonLinkedDataOnly) : []
  });
}
Head.propTypes = {
  head: _propTypes.default.shape({
    meta: _propTypes.default.arrayOf(_propTypes.default.object),
    title: _propTypes.default.string,
    description: _propTypes.default.string,
    content: _propTypes.default.string,
    canonical: _propTypes.default.string,
    keywords: _propTypes.default.string,
    alternate: _propTypes.default.arrayOf(_propTypes.default.shape({
      lang: _propTypes.default.string,
      href: _propTypes.default.string
    })),
    script: _propTypes.default.arrayOf(_propTypes.default.shape({
      type: _propTypes.default.string,
      body: _propTypes.default.string
    }))
  }).isRequired
};
var _default = Head;
exports.default = _default;